import React from "react";
//#region components
import ImportCustomer from "./importCustomer";
//#endregion
//#region types
import { ImportCustomerDialogContentProps } from "models/propTypes/customerPropTypes";
//#endregion
import { ThunkDispatch } from "redux-thunk";
import { closeDialog } from "store/actions/utilActions";
import { useDispatch } from "react-redux";

const ImportCustomerDialogContent: React.FC<ImportCustomerDialogContentProps> = (props) => {
  const { onFormSubmitSuccess } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onSubmitSuccess = () => {
    onFormSubmitSuccess && onFormSubmitSuccess();
    dispatch(closeDialog());
  };

  return <ImportCustomer onFormSubmitSuccess={onSubmitSuccess} />;
};

export default ImportCustomerDialogContent;
